/**
 * Override `toJSON()` method to hide the object value in the Redux devtool.
 * This is to prevent the object from crashing the devtool.
 */
export function hideInDevtool(obj) {
    if (obj) {
        obj.toJSON = () => ({ hidden: 'prevent devtool from crashing' });
    }
}
